const handleShareEmail = (message: string, link: string) => {
  window.location.href = `mailto:?body=${encodeURIComponent(
    message + `${link}`,
  )}`
}
const handleShareWhatsApp = (message: string, link: string) => {
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
    message + `${link}`,
  )}`
  window.open(whatsappUrl, '_blank')
}

const handleShareFacebook = (message: string, link: string) => {
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    `${link}`,
  )}&quote=${encodeURIComponent(message)}`
  window.open(facebookUrl, '_blank')
}

export const shareButtonConfig = (message: string, link: string) => [
  {
    icon: ['far', 'envelope'],
    text: 'Share via e-mail',
    onClick: () => handleShareEmail(message, link),
  },
  {
    icon: ['fab', 'whatsapp'],
    text: 'Share via WhatsApp',
    onClick: () => handleShareWhatsApp(message, link),
  },
  {
    icon: ['fab', 'facebook'],
    text: 'Share via Facebook',
    onClick: () => handleShareFacebook(message, link),
  },
]
